import { useQuery } from "@tanstack/react-query";
import { Address } from "../constants/ProviderGroupFormInitialValues";
import { ProviderGroupControllerApi } from "../services";
import { getConfigObject } from "../utils/utils";

export const PROVIDER_GROUP_PRACTICE_INFO_QUERY_KEY =
  "provider-group-practice-info";

interface ProviderGroupIntakeInfoResponse {
  practiceName?: Record<string, string>;
  practiceNpi?: string;
  practiceContactNumber?: string;
  practiceBillingAddress?: Address;
}

export interface ProviderGroupPracticeInfo {
  name?: string;
  npi?: string;
  phone?: string;
  address?: Address;
}

interface Props {
  xTENANTID?: string;
  isPublic?: boolean;
  enabled?: boolean;
}

/** Practice name, NPI, contact number and billing address of the current tenant's provider group. */
export const useGetProviderGroupPracticeInfo = ({
  xTENANTID,
  isPublic,
  enabled = true,
}: Props) =>
  useQuery({
    queryKey: [PROVIDER_GROUP_PRACTICE_INFO_QUERY_KEY, xTENANTID],
    enabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderGroupControllerApi(isPublic ? undefined : getConfigObject())
        .getProviderGroupPracticeInfo(xTENANTID)
        .then((res) => {
          const info = res?.data?.data as
            ProviderGroupIntakeInfoResponse | undefined;

          return {
            // `practiceName` arrives keyed by provider group uuid, one entry per tenant.
            name: Object.values(info?.practiceName ?? {})[0],
            npi: info?.practiceNpi,
            phone: info?.practiceContactNumber,
            address: info?.practiceBillingAddress,
          } satisfies ProviderGroupPracticeInfo;
        }),
  });
